(() => {
  const bindings = new WeakMap();
  function initialize(panel) {
    const product = document.querySelector('.mobility-product');
    const form = product && product.querySelector('.product-single__form');
    const mainSelect = form && form.querySelector('[name="id"]');
    const mainButton = form && form.querySelector('[data-add-to-cart]');
    const variantData = product && product.querySelector('[data-mobility-vat-variants]');
    if (!form || !mainSelect || !mainButton || !variantData) return;
    if (bindings.get(panel)?.form === form) return;
    bindings.get(panel)?.controller.abort();
    const controller = new AbortController();
    const signal = controller.signal;
    let mainVariants, text, cards;
    try {
      mainVariants = JSON.parse(variantData.textContent);
      text = JSON.parse(panel.querySelector('[data-mobility-accessories-text]').textContent);
      cards = [...panel.querySelectorAll('[data-mobility-accessory]')].map(element => ({
        element, select: element.querySelector('[data-mobility-accessory-variant]'),
        checkbox: element.querySelector('[data-mobility-accessory-check]'),
        quantity: element.querySelector('[data-mobility-accessory-quantity]'),
        variants: JSON.parse(element.querySelector('[data-mobility-accessory-variants]').textContent)
      }));
    } catch (_) { return; }
    const button = panel.querySelector('[data-mobility-accessories-add]');
    const error = panel.querySelector('[data-mobility-accessories-error]');
    const total = panel.querySelector('[data-mobility-accessories-total]');
    const buttonText = button.textContent;
    const hook = product.querySelector('[data-mobility-configurator]');
    const dialog = panel.querySelector('[data-mobility-accessories-dialog]');
    const summary = hook?.querySelector('[data-mobility-accessories-summary]');
    const colourCard = cards.find(card => card.element.dataset.category === 'colour');
    const picker = colourCard?.element.querySelector('[data-mobility-colour-picker]');
    const colourGallery = product.querySelector('[data-mobility-colour-gallery]');
    let galleryDismissed = false;
    let galleryRequested = false;
    const browseCards = cards.filter(card => card !== colourCard);
    const filters = [...panel.querySelectorAll('[data-mobility-accessories-filter]')];
    const search = panel.querySelector('[data-mobility-accessories-search]');
    let adding = false, navigating = false, activeFilter = 'all', opener = null;
    const mainVariant = () => mainVariants.find(variant => String(variant.id) === mainSelect.value);
    const selectedVariant = card => card.variants.find(variant => String(variant.id) === card.select.value);
    const allowed = variant => variant && variant.available && !(variant.options.includes('VAT Relief') && variant.taxable);
    const format = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:panel.dataset.currency}).format(amount / 100);
    const qty = card => Number(card.quantity?.value || 1);
    const replaceCount = (label, count) => (label || '{count}').replace('{count}', count);
    const vatChoice = () => mainVariant()?.options.find(value => value === 'Standard' || value === 'VAT Relief');
    function updateImage(card, variant) {
      const link = card.element.querySelector('[data-mobility-accessory-image-link]');
      let image = card.element.querySelector('[data-mobility-accessory-image]');
      const placeholder = card.element.querySelector('[data-mobility-accessory-placeholder]');
      const price = card.element.querySelector('[data-mobility-accessory-price]');
      const vatLabel = card.element.querySelector('[data-mobility-accessory-vat-label]');
      if (price) price.textContent = variant ? format(variant.price) : text.unavailable;
      if (vatLabel) vatLabel.textContent = variant?.options.includes('VAT Relief') ? text.withRelief : text.includingVAT;
      if (link && variant?.url) link.href = variant.url + '?variant=' + variant.id;
      if (!image && link && variant?.image) {
        image = document.createElement('img');
        image.setAttribute('data-mobility-accessory-image', '');
        image.width = 480; image.height = 480; image.loading = 'lazy';
        link.prepend(image);
      }
      if (image) {
        image.hidden = !variant?.image;
        if (variant?.image && image.getAttribute('src') !== variant.image) {
          image.removeAttribute('srcset');
          image.src = variant.image;
          image.alt = variant.title || card.element.dataset.title || '';
        }
      }
      if (placeholder) placeholder.hidden = !!variant?.image;
    }
    function renderColour() {
      if (!picker) return;
      const variant = selectedVariant(colourCard);
      const chosen = colourCard.checkbox.checked;
      const colour = chosen ? variant.options.find(value => value !== 'Standard' && value !== 'VAT Relief') : '';
      picker.querySelectorAll('[data-mobility-colour-value]').forEach(swatch => {
        const value = swatch.dataset.mobilityColourValue;
        swatch.setAttribute('aria-pressed', String(value === (colour || '')));
        swatch.disabled = adding || (!!value && !colourCard.variants.some(v => v.options.includes(value) && allowed(v)));
      });
      const label = picker.querySelector('[data-mobility-colour-label]');
      const base = picker.querySelector('[data-mobility-colour-value=""]').getAttribute('aria-label');
      label.textContent = chosen ? colour : base;
      const preview = picker.querySelector('[data-mobility-colour-preview]');
      preview.hidden = !chosen;
      if (colourGallery) {
        const previewImage = chosen ? variant.image : picker.dataset.mobilityBaseColourImage;
        const previewColour = chosen ? colour : base;
        colourGallery.hidden = galleryDismissed || (!chosen && !galleryRequested) || !previewImage;
        if (!colourGallery.hidden) {
          const source = new URL(previewImage, window.location.origin);
          source.searchParams.set('width', '1000');
          const image = colourGallery.querySelector('[data-mobility-colour-gallery-image]');
          image.src = source.href; image.alt = previewColour + ' ' + text.coverPreview;
          colourGallery.querySelector('[data-mobility-colour-gallery-caption]').textContent = previewColour + ' · ' + text.coverPreview;
        }
      }
      if (chosen) {
        const image = picker.querySelector('[data-mobility-colour-image]');
        image.hidden = !variant.image;
        if (variant.image) image.src = variant.image;
        image.alt = colour + ' ' + (text.coverPreview || '');
        picker.querySelector('[data-mobility-colour-name]').textContent = colour;
        picker.querySelector('[data-mobility-colour-price]').textContent = '+ ' + format(variant.price);
      }
    }
    function render() {
      const current = mainVariant();
      const chairQuantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value || 1));
      let sum = current ? current.price * chairQuantity : 0;
      cards.forEach(card => {
        const variant = selectedVariant(card);
        const valid = allowed(variant);
        card.checkbox.disabled = adding || !valid;
        if (!valid) card.checkbox.checked = false;
        card.element.classList.toggle('is-selected', card.checkbox.checked);
        if (card.checkbox.checked) sum += variant.price * (Number.isFinite(qty(card)) ? qty(card) : 0);
        updateImage(card, variant);
      });
      const selected = cards.filter(card => card.checkbox.checked);
      total.textContent = text.total + ' ' + format(sum);
      button.disabled = adding || !current || !current.available;
      const footer = panel.querySelector('[data-mobility-accessories-footer]');
      if (footer) footer.hidden = !selected.length;
      const count = panel.querySelector('[data-mobility-accessories-selected]');
      if (count) count.textContent = replaceCount(text.selected, selected.length);
      if (hook) {
        hook.querySelector('[data-mobility-config-total]').textContent = format(sum);
        hook.querySelector('[data-mobility-accessories-count]').textContent = replaceCount(text.available, browseCards.length);
        summary.replaceChildren();
        selected.forEach(card => {
          const variant = selectedVariant(card);
          const line = document.createElement('li');
          const name = document.createElement('span');
          const configuration = variant.configuration || (card === colourCard ? variant.options.find(v => v !== 'Standard' && v !== 'VAT Relief') : '');
          name.textContent = (card.element.dataset.title || variant.title || '') + (configuration ? ' · ' + configuration : '') + ' × ' + qty(card);
          const remove = document.createElement('button');
          remove.type = 'button'; remove.textContent = '×';
          remove.setAttribute('aria-label', (text.remove || 'Remove') + ' ' + name.textContent);
          remove.disabled = adding;
          remove.addEventListener('click', () => {card.checkbox.checked = false; render();}, {signal});
          line.append(name, remove); summary.append(line);
        });
      }
      renderColour();
    }
    function syncVAT() {
      const vat = vatChoice();
      if (vat) cards.forEach(card => {
        const previous = selectedVariant(card);
        const next = card.variants.find(variant => variant.options.includes(vat) && allowed(variant)
          && (!previous?.productId || variant.productId === previous.productId)
          && variant.options.every((value, index) => value === vat || (previous && previous.options[index] === value)));
        if (next) card.select.value = String(next.id);
      });
      render();
    }
    function applyFilter() {
      const term = (search?.value || '').trim().toLocaleLowerCase();
      let count = 0;
      browseCards.forEach(card => {
        const match = (activeFilter === 'all' || card.element.dataset.category === activeFilter)
          && (card.element.dataset.search || card.element.textContent).toLocaleLowerCase().includes(term);
        card.element.hidden = !match;
        if (match) count++;
      });
      const results = panel.querySelector('[data-mobility-accessories-results]');
      if (results) results.textContent = replaceCount(text.results, count);
      const empty = panel.querySelector('[data-mobility-accessories-empty]');
      if (empty) empty.hidden = count > 0;
    }
    function closeDialog() { if (dialog?.open) dialog.close(); opener?.focus(); }
    if (dialog) {
      [...panel.querySelectorAll('[data-mobility-accessories-open]'), ...product.querySelectorAll('[data-mobility-accessories-open]')].forEach(trigger => trigger.addEventListener('click', () => {
        opener = trigger; applyFilter(); dialog.showModal();
      }, {signal}));
      panel.querySelectorAll('[data-mobility-accessories-close]').forEach(trigger => trigger.addEventListener('click', closeDialog, {signal}));
      dialog.addEventListener('cancel', () => {opener?.focus();}, {signal});
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog();
      }, {signal});
      filters.forEach(filter => filter.addEventListener('click', () => {
        activeFilter = filter.dataset.mobilityAccessoriesFilter;
        filters.forEach(other => other.setAttribute('aria-pressed', String(other === filter)));
        applyFilter();
      }, {signal}));
      search?.addEventListener('input', applyFilter, {signal});
    }
    if (picker && hook) {
      product.classList.add('has-cover-picker');
      hook.querySelector('[data-mobility-colour-slot]').replaceChildren(picker);
      colourCard.element.hidden = true;
      picker.querySelectorAll('[data-mobility-colour-value]').forEach(swatch => swatch.addEventListener('click', () => {
        const colour = swatch.dataset.mobilityColourValue;
        galleryDismissed = false;
        galleryRequested = true;
        if (!colour) { colourCard.checkbox.checked = false; render(); return; }
        const variant = colourCard.variants.find(v => v.options.includes(colour) && v.options.includes(vatChoice()) && allowed(v))
          || colourCard.variants.find(v => v.options.includes(colour) && v.options.includes('Standard') && allowed(v));
        if (!variant) return;
        colourCard.select.value = String(variant.id); colourCard.checkbox.checked = true; render();
      }, {signal}));
      colourGallery?.querySelector('[data-mobility-colour-gallery-close]').addEventListener('click', () => {galleryDismissed = true; renderColour();}, {signal});
    }
    function showError(message) { error.textContent = message; error.hidden = false; error.focus(); }
    form.addEventListener('submit', async event => {
      const selected = cards.filter(card => card.checkbox.checked);
      if (!selected.length && !adding) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (adding || mainButton.classList.contains('btn--loading')) return;
      const current = mainVariant();
      if (!current || !current.available || selected.some(card => !allowed(selectedVariant(card)) || !Number.isInteger(qty(card)) || qty(card) < 1 || qty(card) > 99)) {
        showError(text.unavailable); render(); return;
      }
      const data = new FormData(form), quantity = Number(data.get('quantity') || 1);
      if (!Number.isInteger(quantity) || quantity < 1) { showError(text.unavailable); return; }
      const main = {id:current.id,quantity}, properties = {};
      for (const [key,value] of data.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      if (Object.keys(properties).length) main.properties = properties;
      if (data.get('selling_plan')) main.selling_plan = data.get('selling_plan');
      const items = [main, ...selected.map(card => ({id:selectedVariant(card).id,quantity:qty(card)}))];
      const controls = [...product.querySelectorAll('input,select,button'), ...panel.querySelectorAll('input,select,button')];
      const previousDisabled = controls.map(control => control.disabled);
      adding = true; controls.forEach(control => {control.disabled = true;});
      mainButton.classList.add('btn--loading'); button.textContent = text.adding; error.hidden = true;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok || result.status || !Array.isArray(result.items) || items.some(item => !result.items.some(added => String(added.variant_id || added.id) === String(item.id)))) throw new Error('add-failed');
        navigating = true; window.location.assign(panel.dataset.cartUrl);
      } catch (_) {showError(text.error);}
      finally {
        if (!navigating) {
          adding = false; controls.forEach((control,index) => {control.disabled = previousDisabled[index];});
          mainButton.classList.remove('btn--loading'); button.textContent = buttonText; render();
        }
      }
    }, {capture:true,signal});
    button.addEventListener('click', () => form.requestSubmit(mainButton), {signal});
    cards.forEach(card => {
      card.select.addEventListener('change', render, {signal});
      card.checkbox.addEventListener('change', render, {signal});
      card.quantity?.addEventListener('input', render, {signal});
    });
    form.addEventListener('input', event => {if (event.target.name === 'quantity') render();}, {signal});
    mainSelect.addEventListener('change', syncVAT, {signal});
    bindings.set(panel, {form,controller});
    panel.dataset.initialized = 'true';
    if (hook) hook.hidden = false;
    syncVAT(); applyFilter();
  }
  const initializeAll = () => document.querySelectorAll('[data-mobility-accessories]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initializeAll);
  else initializeAll();
  document.addEventListener('shopify:section:load',initializeAll);
})();
